import * as React from 'react';

import { EPage } from '../../constants/pages';
import { MainPageContainer } from '../../containers/MainPageContainer';
import { PaymentPageContainer } from '../../containers/PaymentPageContainer';
import { ServiceAvailabilitySubscribeContainer } from '../../containers/ServiceAvailabilitySubscribeContainer';

export function getPageContent(page: EPage, isServiceUnderMaintenance?: boolean | null): React.ReactElement {
  if (isServiceUnderMaintenance) {
    return <ServiceAvailabilitySubscribeContainer />;
  }

  switch (page) {
    case EPage.Main:
      return <MainPageContainer />;
    case EPage.Payment:
      return <PaymentPageContainer />;
  }
}
